<template>
  <div>
    <vx-card noShadow noRound>
      <vs-row>
        <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
          <InputSelect
            :model.sync="selected_month"
            label="Choose Month"
            :placeholder="selectedMonthLabel"
            container_class="w-auto input-custom-dropdown"
            :options="month_options"
            :multiple="false"
          />
          <vs-input
            v-model="organisation.name"
            label="Name"
            class="w-full"
          />
          <small class="block text-danger mt-1" v-if="api_errors.name">
            {{ api_errors.name.join(', ') }}
          </small>
        </vs-col>
        <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
          <label class="vs-input--label block">Is Active</label>
          <div class="flex mt-3 align-center">
            <vs-radio v-model="organisation.is_active" vs-name="is_active" :vs-value="true">Yes</vs-radio>
            <vs-radio v-model="organisation.is_active" vs-name="is_active" :vs-value="false" class="mx-3">No</vs-radio>
          </div>
          <small class="block text-danger mt-1" v-if="api_errors.is_active">
            {{ api_errors.data.is_active.join(', ') }}
          </small>
        </vs-col>
      </vs-row>
      <vs-row class="mt-base">
        <vs-col class="text-center">
          <vs-button @click="save" :disabled="submit_disabled">
            Save
          </vs-button>
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import { Request } from '../../utils/requests';

export default {
  data() {
    return {
      organisation: {
        name: null,
        is_active: true
      },
      selected_month: null,
      month_options: [
        { value: 1, label: 'January' },
        { value: 2, label: 'February' },
        { value: 3, label: 'March' },
        { value: 4, label: 'April' },
        { value: 5, label: 'May' },
        { value: 6, label: 'June' },
        { value: 7, label: 'July' },
        { value: 8, label: 'August' },
        { value: 9, label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' },
      ],
      submit_disabled: false,
      api_errors: {}
    };
  },
  computed: {
    selectedMonthLabel() {
      const month = this.month_options.find(m => m.value === this.selected_month);
      return month ? month.label : 'Choose Month ...';
    }
  },
  watch: {
    "$route.params.organisation_id"(newV, oldV) {
      if (newV == oldV) return;
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.organisation_id = this.$route.params.organisation_id;
      if (this.organisation_id) this.load_data();
    },
    load_data() {
      let request_method = 'GET', url = this.$store.state.apiendpoints.organisation + this.organisation_id + "/";

      this.$vs.loading();

      Request(this, request_method, url).then(
        res => {
          this.$vs.loading.close();
          this.organisation = res;
          this.selected_month = res.fy_start_month;
        },
        err => {
          this.$vs.loading.close();
          this.$vs.notify({
            time: 3000,
            title: 'Error',
            text: "An unknown error occurred! Please try again!",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      );
    },
    save() {
      let request_method = 'POST', url = this.$store.state.apiendpoints.organisation;
      if (this.organisation_id) {
        request_method = 'PUT';
        url += this.organisation_id + '/';
      }

      let payload = {
        ...this.organisation,
        fy_start_month: this.selected_month
      };

      this.submit_disabled = true;

      Request(this, request_method, url, null, payload).then(
        res => {
          this.organisation = res;
          this.submit_disabled = false;
          this.$vs.notify({
            time: 3000,
            title: 'Saved',
            text: "Saved Successfully!",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
          this.$router.push({ name: 'spv-list' });
        },
        err => {
          this.submit_disabled = false;
          if (err.error) {
            this.api_errors = err.error;
            this.$vs.notify({
              time: 3000,
              title: 'Error',
              text: "Please fix the errors and try again!",
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          } else {
            this.$vs.notify({
              time: 3000,
              title: 'Error',
              text: "An unknown error occurred! Please try again!",
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        }
      );
    }
  }
};
</script>
